const LAMBDA_CODE_BUCKET = 'https://vy-s3-connect-lambda-code.s3.us-east-1.amazonaws.com/';
const LAMBDA_CODE_FILE = 's3_connect_lambda.zip';

export function generateCloudFormationTemplate(
  accountId?: string,
  region?: string,
  bucketName?: string,
): string {
  return `AWSTemplateFormatVersion: "2010-09-09"
  Description: "CloudFormation template for Vayu Connect S3 integration."
  
  Parameters:
    CustomerS3BucketUrl:
      Type: String
      Default: "https://${bucketName}.s3.${region}.amazonaws.com/"
      Description: "The URL of the customer's S3 bucket."
  
  Resources:
    SyncLambdaFunction:
      Type: "AWS::Lambda::Function"
      Properties:
        FunctionName: "CustomerS3PollingLambda"
        Handler: "index.handler"
        Runtime: "nodejs22.x"
        Role: !GetAtt LambdaExecutionRole.Arn
        Code:
          S3Bucket: "${LAMBDA_CODE_BUCKET}"
          S3Key: "${LAMBDA_CODE_FILE}"
        Environment:
          Variables:
            S3_BUCKET_URL: !Ref CustomerS3BucketUrl
            BACKEND_API_URL: "https://connect.withvayu.com"
            CUSTOMER_ID: "${accountId}"
  
    LambdaExecutionRole:
      Type: "AWS::IAM::Role"
      Properties:
        AssumeRolePolicyDocument:
          Version: "2012-10-17"
          Statement:
            - Effect: "Allow"
              Principal:
                Service: "lambda.amazonaws.com"
              Action: "sts:AssumeRole"
        Policies:
          - PolicyName: "LambdaS3Policy"
            PolicyDocument:
              Version: "2012-10-17"
              Statement:
                - Effect: "Allow"
                  Action:
                    - "logs:CreateLogGroup"
                    - "logs:CreateLogStream"
                    - "logs:PutLogEvents"
                  Resource: "*"
                - Effect: "Allow"
                  Action:
                    - "s3:ListBucket"
                  Resource: "arn:aws:s3:::${bucketName}"
  
  Outputs:
    LambdaFunctionArn:
      Value: !GetAtt SyncLambdaFunction.Arn
      Description: "The ARN of the Lambda function."
  `;
}
